document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.c-filter').forEach((root) => {
    const items = [...root.querySelectorAll('.c-filter__item')];
    if (!items.length) return;

    const getLink = (li) => li.querySelector('a[href]');

    const applyActive = (activeLi) => {
      items.forEach((li) => {
        li.classList.toggle('is-active', li === activeLi);
      });
    };

    const pickFromUrl = () => {
      const cur = new URL(window.location.href);
      const useType = items.some((li) => {
        const a = getLink(li);
        return (
          a && new URL(a.href, window.location.origin).searchParams.has('type')
        );
      });

      if (useType) {
        const t = cur.searchParams.get('type');
        for (const li of items) {
          const a = getLink(li);
          if (!a) continue;
          const u = new URL(a.href, window.location.origin);
          const lt = u.searchParams.get('type');
          if (t) {
            if (lt === t) return li;
          } else if (!u.searchParams.has('type')) {
            return li;
          }
        }
        return items[0] || null;
      }

      let c = cur.searchParams.get('category');
      if (!c || c === 'all') c = null;
      for (const li of items) {
        const a = getLink(li);
        if (!a) continue;
        const u = new URL(a.href, window.location.origin);
        const lc = u.searchParams.get('category');
        if (c) {
          if (lc === c) return li;
        } else if (
          !u.searchParams.has('category') ||
          u.searchParams.get('category') === 'all'
        ) {
          return li;
        }
      }
      return items[0] || null;
    };

    // 旧マークアップ: a にだけ is-active → li に移す（見た目は SCSS で a 単体にも対応）
    items.forEach((li) => {
      const a = getLink(li);
      if (a && a.classList.contains('is-active')) {
        li.classList.add('is-active');
        a.classList.remove('is-active');
      }
    });

    const urlLi = pickFromUrl();
    if (!urlLi) return;

    // PHP の is-active が URL と既に一致していれば何もしない（表示直後の再レイアウトを避ける）
    const activeLis = items.filter((li) => li.classList.contains('is-active'));
    if (activeLis.length === 1 && activeLis[0] === urlLi) {
      return;
    }

    applyActive(urlLi);
  });
});
